import React from "react";
import {getBaseURL} from "components/helpers/HostURLHelper.jsx";
import GridContainer from "Grid/GridContainer.jsx";
import GridItem from "Grid/GridItem.jsx";
import ErrorLogo from "@material-ui/icons/Error";
import testModelFormStyle from "components/styles/TestModelFormStyle.js";
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from '@material-ui/core/InputLabel';
import Divider from '@material-ui/core/Divider';
import Grid from "@material-ui/core/Grid";
import Button from "CustomButtons/Button.jsx";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import $ from 'jquery';
import qs from 'query-string';

class ImportTest extends React.Component {

  state = {
    errorMessages:[],
    testInfo: "",
    uploadedFileName: "",
    uploadedFile: "",
    testId: "",
    uploadStatus: "",
    errorsReported: ""
  }

  componentDidMount(){

    const test_id = qs.parse(this.props.location.search).test_id;
    if(test_id){ //Process of duplicate only if test_id exists
        this.setState({testId: test_id});
        $.ajax({
          type: 'GET',
          url: getBaseURL() + '/get-create-test-info.json?test_id=' + test_id,
        }).done((data, status, jqXHR)=>{
          this.setState({testInfo: data["test_info"]});
        }).fail((jqXHR, textStatus, errorThrown) => {
          var errorMessages = this.state.errorMessages;
          errorMessages.push({message: "An Unexpected Error occured while trying to fetch the test details."})
            this.setState({errorMessages: errorMessages});
        })
    }
  }

  handleFileInput = (e) => {
    e.preventDefault();
    var uploadedFileName = e.currentTarget.files[0].name;
    var uploadedFile = e.currentTarget.files[0];
    this.setState({uploadedFileName,uploadedFile});
  }

  handleValidateAndImportFile = (e) => {
   e.preventDefault();
    var formData = new FormData();
    formData.append('offline[doc]', this.state.uploadedFile);
    formData.append('offline[test_id]', this.state.testId);
    
    var url =  e.currentTarget.name;
    
    $.ajax({
          type: 'POST',
          url: url,
          data: formData,
          cache: false,
          contentType: false,
          processData: false
        }).done((data, status, jqXHR)=>{
          this.setState({
            uploadStatus: 'SUCCESS',
            errorsReported: 'No Format Errors Found.'
          });
          if(url == "offline_test"){
            this.props.history.push('/manage-tests');
          }
        }).fail((jqXHR, textStatus, errorThrown) => {

          var errorMessage = ""
          if(jqXHR["responseJSON"] && jqXHR["responseJSON"]["message"]){
            errorMessage = jqXHR["responseJSON"]["message"]
          }else if(jqXHR["responseText"]){
            errorMessage = jqXHR["responseText"]
          }else {
            errorMessage = "Something went wrong. Please verify that the Test Model provided for test does match with the pattern in the uploaded file"
          }

          this.setState({
            uploadStatus: 'FAILED',
            errorsReported: errorMessage
          });
        })
  }

  handleViewTestModel = (e) =>{
      e.preventDefault();
      var testModelId = e.currentTarget.name;
        if(testModelId){
          this.props.history.push('/test_template_infos?viewport=embedded&test_model_id=' + testModelId +'&mode=view');
      }
    }

  render () {
    const {classes} = this.props;
    const {testInfo,uploadedFileName,uploadStatus,errorsReported} = this.state;
    const titleStyle={
      color: "rgb(34, 56, 69)",
      fontWeight: "600",
      fontSize: "20px",
      paddingLeft: "20px",
    };
    const subtitleStyle={
      color: "rgb(34, 56, 69)",
      fontWeight: "600",
      fontSize: "18px",
      fontFamily: "open sans, Helvetica Neue, Helvetica, Arial, sans-serif",
      paddingBottom: "20px"
    };
    const subtitleStyle2={
      color: "rgb(34, 56, 69)",
      fontWeight: "500",
      fontSize: "16px",
      fontFamily: "open sans, Helvetica Neue, Helvetica, Arial, sans-serif",
      paddingBottom: "20px",
      textAlign: "center"
    };
    const smallButtonStyle = {
          textTransform: "none",
          backgroundColor: "#3f51b5",
          color: "white",
          borderRadius: "3px",
          padding: "0.3rem 0.75rem",
          "&:hover,&:focus": {
            color: "white",
            background: "#57849b",
          },
      }
      const paraStyle1={
        whiteSpace: "nowrap", 
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "14px", 
        color: "rgb(34, 56, 69)"
      }
    return (
      <React.Fragment>
      <GridContainer style={{
          backgroundColor: "white",
          paddingTop: "0px",
          paddingBottom: "20px",
          width: "100%", 
          margin: "10px 0px 0px",
          marginTop: "0px"}}
          spacing={24}>
          <GridItem xs={12} sm={12} md={12} style={{paddingTop: "0px", paddingBottom: "0px"}}>
            <h1 style={titleStyle} >Import Test</h1>
            <hr/>
          </GridItem>
        {this.state.errorMessages && this.state.errorMessages.length > 0 &&
        <React.Fragment>
          <GridItem  xs={12} sm={12} md={2} style={{paddingTop: "0px", paddingBottom: "0px"}}>
            </GridItem>
          <GridItem xs={12} sm={12} md={10} style={{paddingTop: "0px", paddingBottom: "0px"}}>
          {this.state.errorMessages && this.state.errorMessages.length > 0 ? this.state.errorMessages.map((errorMessage, index) => 
                  <div key={index}>
                  <ErrorLogo className={classes.icon} style={{verticalAlign: "middle", marginRight: "5px", color: "#f44336"}}></ErrorLogo>
                  <p style={{display: "inline-block", color:"#f44336", fontSize: "0.8rem", overflow: "inherit"}} className={classes.robotoFontRegular}>{errorMessage["message"]}</p> 
                  </div>
                  ): null
                }
              </GridItem>
          </React.Fragment>
          }
          <React.Fragment>
            <GridItem  xs={12} sm={12} md={3}  
              style={{paddingTop: "0px", paddingBottom: "0px", 
                borderRight: "1px solid #eeeeee"}}>
                <React.Fragment>
                <h3 style={subtitleStyle2} >Test Details</h3>
                <Grid container>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <InputLabel shrink htmlFor="material">
                         Test Name
                    </InputLabel>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <p style={paraStyle1} >{testInfo ? testInfo.name : "--"}</p>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <InputLabel shrink htmlFor="material">
                         Test Number
                    </InputLabel>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <p style={paraStyle1} >{testInfo ? testInfo.identifier : "--"}</p>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <InputLabel shrink htmlFor="material">
                         Test Type
                    </InputLabel>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <p style={paraStyle1} >{testInfo ? testInfo.test_type_name : "--"}</p>
                  </Grid>
                </Grid>
                <hr/>
                <h3 style={subtitleStyle2} >Test Model Details</h3>
                <Grid container>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <InputLabel shrink htmlFor="material">
                         Model Name
                    </InputLabel>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <p style={paraStyle1} >{testInfo ? testInfo.template_info_name : "--"}</p>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <InputLabel shrink htmlFor="material">
                         Model Number
                    </InputLabel>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <p style={paraStyle1} >{testInfo ? testInfo.template_info_identifier : "--"}</p>
                  </Grid>
                </Grid>
                <Grid container >
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <InputLabel shrink htmlFor="material">
                         Marks
                    </InputLabel>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <p style={paraStyle1} >{testInfo ? testInfo.total_marks : "--"}</p>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <InputLabel shrink htmlFor="material">
                         Questions
                    </InputLabel>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={1}>
                  </Grid>
                  <Grid item  xs={12} sm={12} md={5}>
                    <p style={paraStyle1} >{testInfo ? testInfo.total_questions : "--"}</p>
                  </Grid>
                </Grid>
                <Grid container direction="column" justify="center" alignItems="center">
                  <Grid item  xs={12} sm={12} md={12}>
                     <Button   
                      size="sm"
                      name={testInfo ? testInfo.test_template_info_id : ""}
                      style={smallButtonStyle}
                      onClick={this.handleViewTestModel}>
                      View Test Model
                    </Button>
                  </Grid>
                </Grid>
                </React.Fragment>
            </GridItem>
            <GridItem  xs={12} sm={12} md={8}  style={{paddingTop: "0px", paddingBottom: "0px", paddingLeft: "40px"}}>
              <div>
              <GridContainer >
                <React.Fragment>
                  <GridItem  xs={12} sm={12} md={12}  style={{paddingTop: "0px", paddingBottom: "0px"}}>
                    <h3 style={subtitleStyle} >Upload Offline Test</h3>
                  </GridItem>
                  <GridItem  xs={12} sm={12} md={7}>
                    <input
                      accept=".docx"
                      className={classes.input}
                      style={{ display: 'none' }}
                      id="raised-button-file"
                      multiple
                      type="file"
                      onChange={this.handleFileInput}
                    />
                    <label htmlFor="raised-button-file">
                      <Button component="span" style={{
                        textTransform: "none",
                        backgroundColor: "#607D8B",
                        padding: "8px 20px",
                        margin: "0px"
                      }}>
                        Upload
                      </Button>
                    </label> 
                    {uploadedFileName &&
                    <p style={{fontSize: "12px", color: "rgb(34, 56, 69)"}} >{uploadedFileName}</p>
                    }
                  {/*</GridItem>
                  <GridItem  xs={12} sm={12} md={8} >*/}
                  </GridItem>
                  <GridItem  xs={12} sm={12} md={5} >
                    <List className={classes.list} style={{padding: "0px"}}>
                      <ListItem className={classes.listItem} style={{paddingTop: "0px"}} >
                        <Button
                          name="offline_test"
                          color="transparent"
                          onClick={this.handleValidateAndImportFile}
                          className={classes.navLink}
                          style={{ 
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          paddingLeft: "20px",
                          paddingRight: "20px"}}
                          size="sm"
                        >
                           Import Test
                        </Button>
                      </ListItem>
                      <ListItem className={classes.listItem} style={{paddingTop: "0px"}}>
                        <Button
                          name="offline_test_validate"
                          onClick={this.handleValidateAndImportFile}
                          color="transparent"
                          style={{ 
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          paddingLeft: "20px",
                          paddingRight: "20px"}}
                          className={classes.navLink}
                          size="sm"
                        >
                           Validate File
                        </Button>
                      </ListItem>
                    </List>
                  </GridItem>
                  <GridItem  xs={12} sm={12} md={12} >
                    <div style={{paddingTop: "20px"}}/>
                    <InputLabel shrink htmlFor="material">
                        Upload Status
                    </InputLabel>
                    <p style={uploadStatus && uploadStatus == "FAILED" ? {fontSize: "16px", color: "#F44336"} :
                              uploadStatus && uploadStatus == "SUCCESS" ?  {fontSize: "16px", color: "#4CAF50"} :
                              {fontSize: "16px", color: "rgb(34, 56, 69)"}}>
                    {uploadStatus ? uploadStatus : "No Validation Performed"}</p>
                    <div style={{paddingTop: "10px"}}/>
                    <InputLabel shrink htmlFor="material">
                        Errors Reported
                    </InputLabel>
                    <div style={{paddingTop: "2px"}}/>
                    <p style={{fontSize: "16px", color: "rgb(34, 56, 69)"}} >{errorsReported ? errorsReported: "No Validation Performed"}</p>
                  </GridItem>
                </React.Fragment>
              </GridContainer>
              </div>
            </GridItem>
          </React.Fragment>
    </GridContainer>
         
      </React.Fragment>
    );
  }
}

export default withStyles(testModelFormStyle)(ImportTest);
